import scrollLock from 'scroll-lock';
import { isTouch } from './utils';

export default class Menu {
	constructor() {
		this.menu = document.querySelector('[data-is="nav-menu"]');
		this.hamburger = document.querySelector('[data-is="hamburger"]');
		this.backbtns = document.querySelectorAll('[data-is="backButton"]');
		this.openSubMenuBtns = document.querySelectorAll('[data-is="open-submenubtn"]');
		this.subMenus = document.querySelectorAll('[data-is="submenu"]');
		
		this.menuIsOpen = false;
		this.breakPoint = 992;

		this.hamburger.addEventListener('click', e => {
			this.toggleMenu();
		});

		this.backbtns.forEach(backbtn => {
			backbtn.addEventListener('click', e => {
				this.closeSubMenu(e);
			});
		});

		this.openSubMenuBtns.forEach(openSubBtn => {
			openSubBtn.addEventListener('click', e => {
				this.openSubMenu(e);
			});
		});
	}

	toggleMenu() {
		if (this.menuIsOpen) {
			this.close();
		} else {
			this.open();
		}
		this.menuIsOpen = !this.menuIsOpen;
	}

	open() {
		this.hamburger.classList.add('is-active');
		this.menu.classList.add('menu-open');
		if (window.innerWidth <= this.breakPoint) {
			scrollLock.disablePageScroll();
		}
	}

	close () {
		this.closeSubMenu();
		this.hamburger.classList.remove('is-active');
		this.menu.classList.remove('menu-open');
		if (window.innerWidth <= this.breakPoint) {
			scrollLock.enablePageScroll();
		}
	}

	openSubMenu(e) {
		e.target.nextElementSibling.classList.add('is-active');
		if (isTouch() && window.innerWidth <= this.breakPoint) {
		}
	}

	closeSubMenu() {
		this.subMenus.forEach(submenu => {
			submenu.classList.remove('is-active');
		})
		if (isTouch() && window.innerWidth <= this.breakPoint) {
		}
	}
}
